import { render, staticRenderFns } from "./DataPanel.vue?vue&type=template&id=27e1f59e&scoped=true&"
import script from "./DataPanel.vue?vue&type=script&lang=ts&"
export * from "./DataPanel.vue?vue&type=script&lang=ts&"
import style0 from "./DataPanel.vue?vue&type=style&index=0&id=27e1f59e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27e1f59e",
  null
  
)

export default component.exports